import { Route, Routes, Navigate } from "react-router-dom"
import * as brands from "brands"
import * as layouts from "layouts"
import * as routing from "./routing"
import * as bgapprovals from "brandguard/display/approval"
import { Scoring } from "brandguard/display/brandguard/scoring"

export default function Routing(): JSX.Element {
	const brand = brands.caching.useCached()
	return (
		<layouts.backgrounds.Grey flex="0 1 100%" height="100%" overflowY="hidden">
			<Routes>
				<Route path="/score" element={<Scoring />} />
				<Route
					path="/approval"
					element={
						<bgapprovals.Container urlgen={routing.approval.upload}>
							<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden">
								<bgapprovals.navigation.WorkflowNav />
								<bgapprovals.UploadsUnified />
							</layouts.containers.flex>
						</bgapprovals.Container>
					}
				/>
				<Route
					path="/approval/review"
					element={
						<bgapprovals.Container urlgen={routing.approval.review}>
							<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden">
								<bgapprovals.navigation.WorkflowNav />
								<bgapprovals.ReviewUnified />
							</layouts.containers.flex>
						</bgapprovals.Container>
					}
				/>
				<Route
					path="/approval/approved"
					element={
						<bgapprovals.Container urlgen={routing.approval.approved}>
							<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden">
								<bgapprovals.navigation.WorkflowNav />
								<bgapprovals.ApprovedUnified />
							</layouts.containers.flex>
						</bgapprovals.Container>
					}
				/>
				<Route
					path="/approval/rejected"
					element={
						<bgapprovals.Container urlgen={routing.approval.rejected}>
							<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden">
								<bgapprovals.navigation.WorkflowNav />
								<bgapprovals.RejectedUnified />
							</layouts.containers.flex>
						</bgapprovals.Container>
					}
				/>
				<Route path="*" element={<Navigate to={routing.score(brand.id)} replace />} />
			</Routes>
		</layouts.backgrounds.Grey>
	)
}
